import './BackButton.scss';

import { CaretLeft } from '@phosphor-icons/react';
import { Body } from '@travelwin/core';
import { useTranslation } from 'react-i18next';

import { useNavigate } from '../Link';

interface Props {
  backButtonLabel?: string;
  onBackButtonClick?: () => void;
}

const className = 'c-BackButton';

const BackButton = ({ backButtonLabel, onBackButtonClick }: Props) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <div
      className={`${className}__back-btn-container`}
      data-testid="button-back"
      onClick={() => (onBackButtonClick ? onBackButtonClick() : navigate(-1))}
    >
      <CaretLeft size={32} weight="bold" />
      <Body accent="title" className={`${className}__back-button`}>
        {backButtonLabel ?? t('btn.back_label', 'Back')}
      </Body>
    </div>
  );
};

export default BackButton;
